<template>
	<div>
        <MenuHeader/>
        <v-main>
            <v-container fluid>
                <slot></slot>
            </v-container>
        </v-main>
    </div>
</template>
<script>
import MenuHeader from "./header"

export default {
    components: {
        MenuHeader,
    }
}
</script>